"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.HeaderRow = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const index_1 = require("../../../../index");
const Interactive_1 = require("../../Text/Interactive/Interactive");
const faCaretUp_1 = require("@fortawesome/free-solid-svg-icons/faCaretUp");
const faCaretDown_1 = require("@fortawesome/free-solid-svg-icons/faCaretDown");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const HeaderRow = ({ children }) => (react_1.default.createElement(react_2.Box, { bgColor: '#F7F6F4', borderY: '1px solid #E7E5DF', as: 'tr', px: '4px' }, children));
exports.HeaderRow = HeaderRow;
const Header = ({ children, sortState, onClick, isSortable = false, isReversed = false, }) => {
    return (react_1.default.createElement("th", { onClick: onClick },
        react_1.default.createElement(react_2.HStack, { p: '8px', justifyContent: 'space-between', flexDir: isReversed ? 'row-reverse' : 'row' },
            react_1.default.createElement(index_1.Text.Interactive, { appearance: 'neutral', size: 'xs', weight: 'semibold', pb: '2px', as: 'span' }, children),
            isSortable && (react_1.default.createElement(react_2.VStack, { color: Interactive_1.colors['neutral']['resting'], _hover: { color: Interactive_1.colors['neutral']['hovered'] }, _active: { color: Interactive_1.colors['neutral']['pressed'] }, gap: 0 },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCaretUp_1.faCaretUp, style: {
                        transition: '250ms ease-in-out',
                        color: sortState === 'asc' ? '#E7E5DF' : Interactive_1.colors['neutral']['resting'],
                    } }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCaretDown_1.faCaretDown, style: {
                        transition: '250ms ease-in-out',
                        color: sortState === 'desc' ? '#E7E5DF' : Interactive_1.colors['neutral']['resting'],
                    } }))))));
};
exports.Header = Header;
